/**
* =========================================================================================
* Component - 404 & 403 Error pages
* =========================================================================================
*/

import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

// 404 Error pages PAGE NOT FOUND
export const Error404 = () => {

    const ORG_ID = useSelector(e => e?.common?.orgId);

    return (
        <div className="u_error-page u_error-page-404">
            <div className="u_error-page-desc u_mb-30">
                <img src="/images/error_404.svg" alt="OOPS! PAGE NOT FOUND" />
                <h2>OOPS! PAGE NOT FOUND</h2>
            </div>
            <div className="u_ib">
                {!window?.location?.pathname?.includes('/employee-onboarding/') &&
                    <Link className="u_error-page-link u_btn u_btn__smallBtn u_btn__blue" to={`/${ORG_ID}/dashboard`}>Go to
                    Dashboard</Link>}
            </div>
        </div>
    );
}

// 403 Error pages Access Forbidden
export const Error403 = () => {

    const ORG_ID = useSelector(e => e?.common?.orgId);

    return (
        <div className="u_error-page u_error-page-403">
            <div className="u_error-page-desc u_mb-30"> 
                <img src="/images/error_403.svg" alt="Access Forbidden" />
                <h2>Access Forbidden</h2>
            </div>
            <div className="u_ib">
                {!window?.location?.pathname?.includes('/employee-onboarding/') &&
                <Link className="u_error-page-link u_btn u_btn__smallBtn u_btn__blue" to={`/${ORG_ID}/dashboard`}>Go to Dashboard</Link>}
            </div>
        </div>
    );
}